import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableCellInfo,
    FormItem,
    FormField,
    FormInput,
    FormLabel,
    Title,
    Icon,
} from 'yurstrap';

import {
    getCookiesGroupSelector,
    getAcceptedCookiesSelector,
    getCookiesByGroupSelector,
    getCookiesIdsByGroupSelector,
    isCookieGroupAcceptedSelector,
    isCookieGroupCollapsedSelector,
    setCookieGroup,
    setCollapsedState,
} from '../reduxModules/ConsentManagementPlatform';

import CMPCookiesRow from './CMPCookiesRow';

const propTypes = {
    AppActions: PropTypes.shape({
        setCookieGroup: PropTypes.func.isRequired,
        setCollapsedState: PropTypes.func.isRequired,
    }).isRequired,
    cookieGroup: PropTypes.object.isRequired,
    cookieContainer: PropTypes.array.isRequired,
    cookies: PropTypes.array.isRequired,
    cookiesIds: PropTypes.array.isRequired,
    isCookieGroupAccepted: PropTypes.bool.isRequired,
    isCollapsed: PropTypes.bool.isRequired,
};

export class CMPCookiesGroup extends Component {

    constructor(props) {
        super(props);
        this.collapseCookieList = this.collapseCookieList.bind(this);
        this.toggleCookieGroup = this.toggleCookieGroup.bind(this);
    }

    collapseCookieList() {
        const {
            cookieGroup,
            AppActions,
            isCollapsed,
        } = this.props;
        const cookieGroupId = cookieGroup.id;
        AppActions.setCollapsedState(cookieGroupId, !isCollapsed);
    }

    toggleCookieGroup() {
        const {
            AppActions,
            cookiesIds,
            isCookieGroupAccepted,
        } = this.props;
        AppActions.setCookieGroup(cookiesIds, !isCookieGroupAccepted);
    }

    renderCookieRow() {
        const {
            cookies,
            isCollapsed,
        } = this.props;
        if (isCollapsed) return null;
        return _.map(cookies, (cookie) => (
            <CMPCookiesRow
                key={cookie.id}
                cookieId={cookie.id}
            />
        ));
    }

    renderGlobalSetupForGroup() {
        const {
            cookieGroup,
            isCookieGroupAccepted,
            isCollapsed,
        } = this.props;
        if (isCollapsed) return null;
        // In case the group has only one cookie, no need to render a global setup
        if (cookieGroup.cookies.length <= 1) return null;
        return (
            <TableRow>
                <TableCell>
                    <Title
                        componentClass="h6"
                    >
                        {`Préférences globales pour ${cookieGroup.name}`}
                    </Title>
                </TableCell>
                <TableCell>
                    <FormItem className="m-0">
                        <FormField type="toggle">
                            <FormInput
                                className="p-3"
                                id={cookieGroup.id}
                                type="checkbox"
                                checked={isCookieGroupAccepted}
                                onChange={this.toggleCookieGroup}
                            />
                            <FormLabel
                                htmlFor={cookieGroup.id}
                            />
                        </FormField>
                    </FormItem>
                </TableCell>
            </TableRow>
        );
    }

    render() {
        const {
            cookieGroup,
            isCollapsed,
        } = this.props;
        return (
            <Table
                key={cookieGroup.id}
                className="mb-3"
                border
            >
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Title
                                componentClass="h6"
                                className="txt_hyphenate m-0"
                            >
                                {cookieGroup.name}
                            </Title>
                            <TableCellInfo>
                                {cookieGroup.description}
                            </TableCellInfo>
                        </TableCell>
                        <TableCell
                            className="u-text-align__center"
                        >
                            <Icon
                                collection="yp"
                                className="p-3 s-iconaction__icon"
                                icon={isCollapsed ? 'chevron-down' : 'chevron-up'}
                                onClick={this.collapseCookieList}
                            />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.renderGlobalSetupForGroup()}
                    {this.renderCookieRow()}
                </TableBody>
            </Table>
        );
    }

}

CMPCookiesGroup.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        cookieContainer: getAcceptedCookiesSelector(state),
        cookieGroup: getCookiesGroupSelector(state, ownProps.cookieGroupId),
        cookies: getCookiesByGroupSelector(state, ownProps.cookieGroupId),
        cookiesIds: getCookiesIdsByGroupSelector(state, ownProps.cookieGroupId),
        isCookieGroupAccepted: isCookieGroupAcceptedSelector(state, ownProps.cookieGroupId),
        isCollapsed: isCookieGroupCollapsedSelector(state, ownProps.cookieGroupId),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCookieGroup,
            setCollapsedState,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CMPCookiesGroup);
